// extracted by mini-css-extract-plugin
module.exports = {"create-asset":"create-asset-2gMYV","createAsset":"create-asset-2gMYV","spinner":"spinner-_OZJM"};